export enum CellId {
    CLOSE_VALUE = 'CLOSE_VALUE',
    OPEN_VALUE = 'OPEN_VALUE',
    CLOSE_RECLASSE_VALUE = 'CLOSE_RECLASSE_VALUE',
    OPEN_RECLASSE_VALUE = 'OPEN_RECLASSE_VALUE',
    CLOSE_ADJUSTEMENT_VALUE = 'CLOSE_ADJUSTEMENT_VALUE',
    OPEN_ADJUSTEMENT_VALUE = 'OPEN_ADJUSTEMENT_VALUE',
    CLOSE_INTERNAL_VALUE = 'CLOSE_INTERNAL_VALUE',
    OPEN_INTERNAL_VALUE = 'OPEN_INTERNAL_VALUE',
    CHANGE_IN_ADJUSTMENTS = 'CHANGE_IN_ADJUSTMENTS',
}
